import {Injectable} from '@angular/core';
import {CommonHttpService} from "./common-http.service";
import {AuthHttpService} from "./auth-http.service";
import {AppResponse} from "./app-response.model";
import {PasswordRecoveryRequest} from "../auth/auth.model";
import {Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class PasswordsApiService {

  constructor(
    private http: CommonHttpService,
    private authHttp: AuthHttpService
  ) {

  }

  recover(request: PasswordRecoveryRequest): Observable<AppResponse<void>> {
    return this.http.post<void>("/password/recover", request);
  }

  reset(password: string): Observable<AppResponse<void>> {
    return this.authHttp.post<void>("/password/reset", password);
  }

}
